<template>
  <div class="footbar">
    <van-tabbar
      :fixed="false"
      v-model="bar"
      @change="onChange"
      v-if="barConf && barConf.length"
      active-color="#FF8522"
      inactive-color="#B0B1BE"
    >
      <van-tabbar-item
        v-for="item in barConf"
        :key="item.path"
        replace
        :to="item.path"
        :name="item.name"
        :icon="item.icon"
        >{{ item.txt }}
        <template #icon="props">
          <img :src="props.active ? item.icon_c : item.icon" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { BARCONF } from "@/configs/configs";
export default {
  name: "navbar",
  components: {},
  computed: {
    bar: {
      get() {
        return this.navbar;
      },
      set() {},
    },
    ...mapGetters(["navbar"]),
  },
  data() {
    return {
      barConf: BARCONF,
    };
  },
  created() {
    console.log(this.navbar);
  },
  mounted() {},
  methods: {
    onChange(index) {
      //this.navbar = index;
      this.SET_NAVBAR(index);
    },
    ...mapMutations("navbar", ["SET_NAVBAR"]),
  },
};
</script>

<style lang="scss" scoped>
.footbar {
  position: fixed;
  z-index: 999;
  width: 100%;
  bottom: 0;
  max-width: 9rem;
}
</style>
